var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"dashboard"}},[_c('Sidebar',{on:{"opened":function($event){_vm.active = $event}}},[_c('SideGroup',{attrs:{"active":_vm.active}})],1),_c('Home')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }